export const CityExperience = ({ city }) => (
<>
<h4 className="text-xl font-bold text-yellow-400 mt-6 mb-3">
                      Pourquoi Choisir Maître Diamma à {city} ?
                    </h4>
                    
                    <p className="text-base md:text-lg">
                      Ce <strong className="text-white">grand marabout africain traditionnel</strong> exerce à {city} depuis plus de 15 ans. 
                      Héritier d'une longue lignée de maîtres vaudou africains, Maître Diamma pratique la <strong className="text-yellow-400">sorcellerie vaudou authentique</strong> 
                      transmise de génération en génération. À {city}, des personnes ont déjà fait appel à ses services 
                      pour des problèmes de retour affectif, d'amour, de couple, de désenvoûtement, de protection spirituelle ou de voyance. 
                      Les habitants de {city} le considèrent comme le <strong className="text-white">marabout le plus puissant et le plus sérieux</strong> 
                      de toute la Guadeloupe.
                    </p>
                    
                    <p className="text-base md:text-lg">
                      Que vous soyez au centre de {city}, dans les quartiers périphériques ou aux alentours de {city}, 
                      le <strong className="text-yellow-400">marabout Maître Diamma se déplace rapidement</strong> pour vos consultations urgentes. 
                      Il est également disponible pour des consultations à distance par téléphone ou WhatsApp pour les résidents de {city} 
                      qui préfèrent une première approche discrète. Ses <strong className="text-white">rituels de retour affectif à {city}</strong> 
                      ont permis à des couples de se retrouver après des séparations difficiles, des infidélités, 
                      des disputes ou même quand l'ex était en couple avec quelqu'un d'autre.
                    </p>
</>
);
